<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<h1 class="toc-title">Contents</h1>
<p class="toc"><span href="#/Text/part0001" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-part" id="part-1"><a href="#/Text/part0005"><strong>Section One</strong><br/>Truckbox Al’s Big Break</a></p>
<p class="toc-part" id="part-2"><span href="#/Text/part0011" title="Link target outside of Sample"><strong>Section Two</strong><br/>The Full Scholarship Orphaned Genius</span></p>
<p class="toc-part" id="part-3"><span href="#/Text/part0016" title="Link target outside of Sample"><strong>Section Three</strong><br/>The Little Box Social</span></p>
<p class="toc-part" id="part-4"><span href="#/Text/part0022" title="Link target outside of Sample"><strong>Section Four</strong><br/>Bob Feller, Hal Newhouser, and Joe DiMaggio Himself</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0004.vue?022ea2b0